"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/CreateNew/NewChat/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);






var _chat = require('shared/enum/chat');
var _contact = require('shared/enum/contact');
var _createNew = require('shared/hooks/createNew');
var _createNew3 = require('shared/selectors/createNew');
var _entity = require('shared/services/entity');
var _newChatFlow = require('shared/services/createNew/newChatFlow');
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);

var _amplitude = require('web/services/amplitude'); var _amplitude2 = _interopRequireDefault(_amplitude);
var _hooks = require('web/services/hooks');
var _Modal = require('web/components/Modal'); var _Modal2 = _interopRequireDefault(_Modal);
var _Avatar = require('web/components/Avatar');
var _CreateNew = require('web/screens/CreateNew'); var _CreateNew2 = _interopRequireDefault(_CreateNew);
var _user = require('shared/selectors/user');
var _ToField = require('../Compose/ToField'); var _ToField2 = _interopRequireDefault(_ToField);
var _useToSearch = require('../Compose/useToSearch');
var _icons = require('../Compose/icons');
var _DraftChat = require('./DraftChat'); var _DraftChat2 = _interopRequireDefault(_DraftChat);
var _parts = require('./parts');
var _Cards = require('./Cards');


















// SAFETY: every sender and patient entity wraps a record with an OrgKey.
const orgKeyOf = (entity) => (entity.wrappedEntity ).OrgKey

/* "New chat" (design D, WhatsApp-style) in a centred modal over the open chat.
 * One coworker → Message opens your chat with them (or a new one, from
 * today's default sender: no From). One patient → Message → Secure or SMS,
 * From only when two or more texting teams could send it. Several → Create
 * group → New group: an optional Name and From. */
const NewChat = ({ chatType, initialEntitiesList, isVisible = true, gotoConversation, onCloseCreateNewChat, onFinished, onDraftChange }) => {
  const chat = _createNew.useNewChat.call(void 0, { initialEntitiesList, initialChannel: chatType === _chat.CHAT_TYPE.REGULAR_PATIENT ? 'insecure' : 'secure' })
  const { selectedEntitiesList, selectedEntitiesMap, onSelectEntity, onRemoveEntity, getDisabled, patient } = chat
  _react.useEffect.call(void 0, () => { _amplitude2.default.logEvent('Open Create Chat', { chatType, redesign: true, flow: 'new-chat' }) }, [chatType])

  const [step, setStep] = _react.useState('pick')
  _react.useEffect.call(void 0, () => { _optionalChain([onDraftChange, 'optionalCall', _ => _(step === 'chat')]) }, [step, onDraftChange])
  // Picking people for a group: 'members' from the New group shortcut (Add
  // members, then Next), 'more' from New group's Add tile (Add people, Done).
  const [adding, setAdding] = _react.useState(null)
  const isAddingToGroup = !!adding
  const [error, setError] = _react.useState(null)
  _react.useEffect.call(void 0, () => setError(null), [step, selectedEntitiesList])

  const finish = _react.useCallback.call(void 0, (meta) => {
    _optionalChain([onFinished, 'optionalCall', _2 => _2()])
    gotoConversation(meta.Type, meta.ConversationKey, meta.BlobjectKey)
  }, [onFinished, gotoConversation])

  // ---- Pick
  const toInputRef = _react.useRef(null)
  _react.useEffect.call(void 0, () => {
    if (isVisible && step === 'pick') _optionalChain([toInputRef, 'access', _3 => _3.current, 'optionalAccess', _4 => _4.focus, 'call', _5 => _5()])
  }, [isVisible, step])
  const excludedEntitiesMap = _createNew.useExcludedEntities.call(void 0, { selectedEntitiesMap, senderEntity: chat.senderEntity })
  const recentList = _hooks.useAppSelector.call(void 0, _createNew3.selectRecentChatEntities)
  const { staffList } = _createNew.useOrgStaff.call(void 0, chat.searchOrgKey)
  const recentKeys = _react.useMemo.call(void 0, () => new Set(recentList.map(e => e.entityKey)), [recentList])
  const staffShown = _react.useMemo.call(void 0, () => staffList.filter(e => !recentKeys.has(e.entityKey)), [staffList, recentKeys])
  const onPickEntity = _react.useCallback.call(void 0, (entity) => {
    if (getDisabled(entity) || selectedEntitiesMap[entity.entityKey]) return
    setError(null)
    onSelectEntity(entity)
  }, [getDisabled, onSelectEntity, selectedEntitiesMap])
  // Ticking a row keeps typing in To, as WhatsApp does.
  const toggleEntity = _react.useCallback.call(void 0, (entity) => {
    if (selectedEntitiesMap[entity.entityKey]) onRemoveEntity(entity.entityKey)
    else onPickEntity(entity)
    _optionalChain([toInputRef, 'access', _6 => _6.current, 'optionalAccess', _7 => _7.focus, 'call', _8 => _8()])
  }, [selectedEntitiesMap, onRemoveEntity, onPickEntity])
  const onInvitedEntity = _react.useCallback.call(void 0, (entity) => {
    if (_entity.isEntityPatient.call(void 0, entity) && !patient && orgKeyOf(entity) !== chat.senderOrgKey) chat.resetStickiness()
    onPickEntity(entity)
  }, [patient, chat, onPickEntity])
  // Typing in To filters the list in place (no popover), as WhatsApp does.
  const search = _useToSearch.useToSearch.call(void 0, {
    orgKey: chat.searchOrgKey,
    patientOrgKey: patient ? orgKeyOf(patient) : null,
    canAddPatients: chat.hasPatientMessaging,
    canAddStaff: true,
    selectedEntitiesList,
    excludedEntitiesMap,
    inputRef: toInputRef,
    onSelectEntity: onPickEntity,
    onInvitedEntity,
    onRemoveEntity,
  })
  const { clearQuery } = search
  const { openInvite } = search
  const onAddPatient = _react.useCallback.call(void 0, () => openInvite(_contact.CONTACT_REL_TYPES.PATIENT), [openInvite])
  const onAddCoworker = _react.useCallback.call(void 0, () => openInvite(_contact.CONTACT_REL_TYPES.COWORKER), [openInvite])
  const onAddCollaborator = _react.useCallback.call(void 0, () => openInvite(_contact.CONTACT_REL_TYPES.EXTERNAL), [openInvite])
  // Video call: today's "Start a video chat", in place of New chat.
  const hasVideo = !!_hooks.useAppSelector.call(void 0, _user.selectCurrentUserHasVideoV1Feature)
  const [isVideoOpen, setIsVideoOpen] = _react.useState.call(void 0, false)
  const onVideoCall = _react.useCallback.call(void 0, () => setIsVideoOpen(true), [])

  const primary = _newChatFlow.primaryActionFor.call(void 0, selectedEntitiesList)
  // Which shortcut rows show, and where (top, or "More" at the bottom).
  const shortcuts = _newChatFlow.shortcutsFor.call(void 0, {
    hasQuery: search.hasQuery,
    recipientCount: selectedEntitiesList.length,
    canAddPatients: chat.hasPatientMessaging,
    canAddCoworkers: !!chat.searchOrgKey,
    canAddCollaborators: !!chat.searchOrgKey,
    hasVideo,
  })

  // Message / Open chat / Create wait for the existing-chat lookup, then go.
  const [queued, setQueued] = _react.useState(null)
  const isBusyRef = _react.useRef.call(void 0, false)
  const [isBusy, setIsBusy] = _react.useState.call(void 0, false)
  const openChat = _react.useCallback.call(void 0, () => {
    if (chat.blocker) return setError(chat.blocker)
    if (chat.isMatching) return setQueued('open')
    setQueued(null)
    if (chat.reusableMatch) return finish(chat.reusableMatch)
    setStep('chat')
  }, [chat.blocker, chat.isMatching, chat.reusableMatch, finish])
  const createGroup = _react.useCallback.call(void 0, async () => {
    if (isBusyRef.current) return
    if (chat.blocker) return setError(chat.blocker)
    if (chat.isMatching) return setQueued('create')
    setQueued(null)
    if (chat.reusableMatch) return finish(chat.reusableMatch)
    isBusyRef.current = true
    setIsBusy(true)
    try {
      finish(await chat.createChat())
    } catch (e2) {
      setError('Couldn\'t create the group. Check the details and try again.')
    } finally {
      isBusyRef.current = false
      setIsBusy(false)
    }
  }, [chat, finish])
  _react.useEffect.call(void 0, () => {
    if (!queued || chat.isMatching) return
    if (queued === 'open') openChat()
    else createGroup()
  }, [queued, chat.isMatching, openChat, createGroup])
  _react.useEffect.call(void 0, () => setQueued(null), [selectedEntitiesList, chat.senderEntity, chat.channel])

  const onPrimary = _react.useCallback.call(void 0, () => {
    clearQuery()
    if (adding === 'members') {
      setAdding(null)
      return setStep('group')
    }
    if (adding === 'more') {
      setAdding(null)
      return setStep(primary.next === 'patient' ? 'patient' : 'group')
    }
    if (primary.next === 'group') return setStep('group')
    if (primary.next === 'patient') return setStep('patient')
    openChat()
  }, [adding, primary.next, openChat, clearQuery])
  // New group with nobody picked yet: Add members first, as WhatsApp does.
  const onNewGroup = _react.useCallback.call(void 0, () => {
    clearQuery()
    setAdding('members')
    _optionalChain([toInputRef, 'access', _9 => _9.current, 'optionalAccess', _10 => _10.focus, 'call', _11 => _11()])
  }, [clearQuery])
  const leaveAdding = _react.useCallback.call(void 0, () => {
    clearQuery()
    if (adding === 'more') return onPrimary()
    setAdding(null)
  }, [adding, onPrimary, clearQuery])
  const { resetChoices } = chat
  const backOutToPick = _react.useCallback.call(void 0, () => {
    resetChoices()
    setStep('pick')
  }, [resetChoices])
  const onAddPeople = _react.useCallback.call(void 0, () => {
    setAdding('more')
    setStep('pick')
  }, [])
  // Send from: its own page, back to the step it came from.
  const [fromReturn, setFromReturn] = _react.useState('group')
  const openFrom = _react.useCallback.call(void 0, (from) => {
    setFromReturn(from)
    setStep('from')
  }, [])
  const { chooseSender } = chat
  const onPickSender = _react.useCallback.call(void 0, (key) => {
    chooseSender(key)
    setStep(fromReturn)
  }, [chooseSender, fromReturn])

  // Above the return below: hiding New chat keeps the unsent message.
  const draft = _DraftChat.useDraftMessage.call(void 0, )

  if (!isVisible) return null

  if (isVideoOpen) {
    return _react2.default.createElement(_CreateNew2.default, { open: true, selectedTab: _CreateNew.CreateNewTypes.VIDEO, onClose: onCloseCreateNewChat, __self: this, __source: {fileName: _jsxFileName, lineNumber: 219}} )
  }

  if (step === 'chat') {
    return _react2.default.createElement(_DraftChat2.default, { chat: chat, draft: draft, onBack: () => setStep(patient ? 'patient' : 'pick'), onOpen: finish, __self: this, __source: {fileName: _jsxFileName, lineNumber: 223}} )
  }

  let content
  if (step === 'group' || step === 'patient') {
    content = (
      _react2.default.createElement(_Cards.CardsStep, {
        chat: chat,
        step: step,
        onBack: backOutToPick,
        onAction: step === 'group' ? createGroup : openChat,
        isBusy: step === 'group' ? isBusy || queued === 'create' : queued === 'open',
        onSendFrom: () => openFrom(step),
        onAddPeople: onAddPeople,
        error: error, __self: this, __source: {fileName: _jsxFileName, lineNumber: 229}}
      )
    )
  } else if (step === 'from') {
    content = _react2.default.createElement(_Cards.SendFromStep, { chat: chat, onBack: () => setStep(fromReturn), onPick: onPickSender, isPatient: fromReturn === 'patient', __self: this, __source: {fileName: _jsxFileName, lineNumber: 241}} )
  } else {
    const renderShortcut = (shortcut) => {
      if (shortcut === 'new-group') {
        return _react2.default.createElement(ShortcutRow, { key: shortcut, icon: _react2.default.createElement(_icons.PeopleIcon, { size: 20, __self: this, __source: {fileName: _jsxFileName, lineNumber: 245}} ), label: "New group" , description: "Name it and choose who it's from"      , onClick: onNewGroup, __self: this, __source: {fileName: _jsxFileName, lineNumber: 245}} )
      }
      if (shortcut === 'add-patient') return _react2.default.createElement(ShortcutRow, { key: shortcut, icon: _react2.default.createElement(_icons.PersonPlusIcon, { size: 20, __self: this, __source: {fileName: _jsxFileName, lineNumber: 247}} ), label: "Add a patient"  , onClick: onAddPatient, __self: this, __source: {fileName: _jsxFileName, lineNumber: 247}} )
      if (shortcut === 'add-coworker') return _react2.default.createElement(ShortcutRow, { key: shortcut, icon: _react2.default.createElement(_icons.PersonPlusIcon, { size: 20, __self: this, __source: {fileName: _jsxFileName, lineNumber: 248}} ), label: "Add a coworker"  , onClick: onAddCoworker, __self: this, __source: {fileName: _jsxFileName, lineNumber: 248}} )
      if (shortcut === 'add-collaborator') return _react2.default.createElement(ShortcutRow, { key: shortcut, icon: _react2.default.createElement(_icons.PersonPlusIcon, { size: 20, __self: this, __source: {fileName: _jsxFileName, lineNumber: 249}} ), label: "Add an external collaborator"   , onClick: onAddCollaborator, __self: this, __source: {fileName: _jsxFileName, lineNumber: 249}} )
      return _react2.default.createElement(ShortcutRow, { key: shortcut, icon: _react2.default.createElement(_icons.VideoIcon, { size: 20, __self: this, __source: {fileName: _jsxFileName, lineNumber: 250}} ), label: "Video call" , onClick: onVideoCall, __self: this, __source: {fileName: _jsxFileName, lineNumber: 250}} )
    }
    const moreSection = shortcuts.more.length
      ? (
          _react2.default.createElement('div', { role: "group", 'aria-label': "More", __self: this, __source: {fileName: _jsxFileName, lineNumber: 254}}
            , _react2.default.createElement(Band, { label: "More", __self: this, __source: {fileName: _jsxFileName, lineNumber: 255}} )
            ,  shortcuts.more.map(renderShortcut) 
          )
        )
      : null
    const action = adding === 'members' ? 'Next' : adding === 'more' ? 'Done' : primary.label
    const oneName = _optionalChain([selectedEntitiesList, 'access', _12 => _12[0], 'optionalAccess', _13 => _13.name])
    content = (
      _react2.default.createElement(_react2.default.Fragment, null
        , _react2.default.createElement(_parts.Header, {
          left: isAddingToGroup ? 'back' : 'close',
          onLeft: isAddingToGroup ? leaveAdding : onCloseCreateNewChat,
          title: adding === 'members' ? 'Add members' : adding === 'more' ? 'Add people' : 'New chat',
          subtitle: adding === 'members' ? `${selectedEntitiesList.length} selected` : undefined,
          action: action,
          isActionEnabled: adding === 'members' ? selectedEntitiesList.length > 0 : isAddingToGroup || primary.isEnabled,
          isActionBusy: queued === 'open',
          onAction: onPrimary, __self: this, __source: {fileName: _jsxFileName, lineNumber: 264}}
        )
        , _react2.default.createElement('div', { className: "new-chat--rows", __self: this, __source: {fileName: _jsxFileName, lineNumber: 274}}
          , _react2.default.createElement(_ToField2.default, {
            search: search,
            resultsId: RESULTS_ID,
            selectedEntitiesList: selectedEntitiesList,
            inputRef: toInputRef,
            onRemoveEntity: onRemoveEntity,
            placeholder: "Name, team or patient"   , __self: this, __source: {fileName: _jsxFileName, lineNumber: 275}}
          )
        )
        ,  search.hasQuery
          ? (
              _react2.default.createElement('div', { className: "new-chat--list", __self: this, __source: {fileName: _jsxFileName, lineNumber: 286}}
                , _react2.default.createElement(_parts.ErrorLine, { message: error, __self: this, __source: {fileName: _jsxFileName, lineNumber: 287}} )
                , _react2.default.createElement(SearchResults, { search: search, isDisabled: getDisabled, __self: this, __source: {fileName: _jsxFileName, lineNumber: 288}} )
                ,  moreSection 
              )
            )
          : (
        _react2.default.createElement('div', { className: "new-chat--list", __self: this, __source: {fileName: _jsxFileName, lineNumber: 293}}
          , _react2.default.createElement(_parts.ErrorLine, { message: error, __self: this, __source: {fileName: _jsxFileName, lineNumber: 294}} )
          ,  !isAddingToGroup && shortcuts.top.map(renderShortcut) 
          ,  !!recentList.length && _react2.default.createElement(Band, { label: "Recent", __self: this, __source: {fileName: _jsxFileName, lineNumber: 296}} ) 
          ,  recentList.map(entity => (
            _react2.default.createElement(PickRow, { key: entity.entityKey, entity: entity, isOn: !!selectedEntitiesMap[entity.entityKey], isDisabled: getDisabled(entity), onToggle: toggleEntity, __self: this, __source: {fileName: _jsxFileName, lineNumber: 298}} )
          ))
          ,  !!staffShown.length && _react2.default.createElement(Band, { label: "Staff", __self: this, __source: {fileName: _jsxFileName, lineNumber: 300}} ) 
          ,  staffShown.map(entity => (
            _react2.default.createElement(PickRow, { key: entity.entityKey, entity: entity, isOn: !!selectedEntitiesMap[entity.entityKey], isDisabled: getDisabled(entity), onToggle: toggleEntity, __self: this, __source: {fileName: _jsxFileName, lineNumber: 302}} )
          ))
          ,  moreSection 
        )
            )
        /* Under the list, so the rows don't move when it appears. */
        ,  !search.hasQuery && !isAddingToGroup && primary.next === 'chat' && !!chat.reusableMatch && !!oneName && (
          _react2.default.createElement(Note, { icon: _react2.default.createElement(_icons.BubbleIcon, { size: 14, __self: this, __source: {fileName: _jsxFileName, lineNumber: 309}} ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 309}}, "You already have a chat with "
                  , _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 310}},  oneName ), ". Message opens it."
          )
        )
      )
    )
  }

  // Escape backs out a step (in To, it first clears what's typed: ToField).
  const backOut = step === 'pick' && !isAddingToGroup
    ? onCloseCreateNewChat
    : step === 'pick' ? leaveAdding : step === 'from' ? () => setStep(fromReturn) : backOutToPick
  // (The From menu handles its own Escape.)
  const onEscape = backOut
  return (
    _react2.default.createElement(_Modal2.default, {
      isOpen: true,
      onClose: onCloseCreateNewChat,
      onEscape: onEscape,
      ariaLabel: step === 'group' ? 'New group' : step === 'from' ? 'Send from' : adding === 'members' ? 'Add members' : 'New chat',
      className: _classBuilder2.default.call(void 0, 'new-chat', step === 'pick' ? 'new-chat---tall' : 'new-chat---cards'),
      bodyClassName: "new-chat--body", __self: this, __source: {fileName: _jsxFileName, lineNumber: 324}}

      ,  content 
    )
  )
}

const RESULTS_ID = 'new-chat-results'

// What To finds, in New chat's list: a band per kind, rows like the list's
// own (avatar, name, subtitle, select circle), the highlighted one following
// the arrow keys; "No results" when nothing matches.
const SearchResults = ({ search, isDisabled }) => {
  // The highlighted row stays in view as the arrow keys move it.
  _react.useEffect.call(void 0, () => {
    _optionalChain([document, 'access', _14 => _14.getElementById, 'call', _15 => _15(_useToSearch.searchOptionId.call(void 0, search.active)), 'optionalAccess', _16 => _16.scrollIntoView, 'optionalCall', _17 => _17({ block: 'nearest' })])
  }, [search.active])
  let index = -1
  return (
    _react2.default.createElement('div', { id: RESULTS_ID, role: "listbox", 'aria-labelledby': "compose-to-label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 349}}
      ,  search.groups.map(group => (
        _react2.default.createElement('div', { key: group.label, role: "group", 'aria-label': group.label, __self: this, __source: {fileName: _jsxFileName, lineNumber: 351}}
          , _react2.default.createElement(Band, { label: group.label, __self: this, __source: {fileName: _jsxFileName, lineNumber: 352}} )
          ,  group.options.map(option => {
            index++
            return (
              _react2.default.createElement(ResultRow, {
                key: option.id,
                option: option,
                index: index,
                isActive: index === search.active,
                isDisabled: isDisabled(option.entity),
                onHover: search.setActive,
                onPick: search.pick, __self: this, __source: {fileName: _jsxFileName, lineNumber: 356}}
              )
            )
          })
        )
      ))
      ,  search.phoneError && _react2.default.createElement(_parts.ErrorLine, { message: search.phoneError, __self: this, __source: {fileName: _jsxFileName, lineNumber: 369}} ) 
      ,  search.isEmpty && _react2.default.createElement('div', { className: "new-chat--empty", role: "status", __self: this, __source: {fileName: _jsxFileName, lineNumber: 370}}, "No results" ) 
    )
  )
}










const ResultRow = ({ option, index, isActive, isDisabled, onHover, onPick }) => (
  _react2.default.createElement('div', {
    id: _useToSearch.searchOptionId.call(void 0, index),
    role: "option",
    'aria-selected': isActive,
    'aria-disabled': isDisabled || undefined,
    className: _classBuilder2.default.call(void 0, 
      'new-chat--row', 'new-chat--row---button',
      isActive && 'new-chat--row---active',
      isDisabled && 'new-chat--row---disabled',
    ),
    onMouseEnter: () => onHover(index),
    // Keep focus (and typing) in To.
    onMouseDown: e => e.preventDefault(),
    onClick: () => { if (!isDisabled) onPick(option) }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 385}}

    , _react2.default.createElement(_Avatar.EntityAvatar, { entity: option.entity, size: 40, __self: this, __source: {fileName: _jsxFileName, lineNumber: 400}} )
    , _react2.default.createElement('span', { className: "new-chat--row-text", __self: this, __source: {fileName: _jsxFileName, lineNumber: 401}}
      , _react2.default.createElement('span', { className: "new-chat--row-names", __self: this, __source: {fileName: _jsxFileName, lineNumber: 402}}
        , _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 403}},  option.entity.name )
        ,  option.entity.description && _react2.default.createElement('small', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 404}},  option.entity.description ) 
      )
      , _react2.default.createElement('span', { className: "new-chat--sel", __self: this, __source: {fileName: _jsxFileName, lineNumber: 406}} )
    )
  )
)

const Band = ({ label }) => _react2.default.createElement('div', { className: "new-chat--band", role: "heading", 'aria-level': 4, __self: this, __source: {fileName: _jsxFileName, lineNumber: 411}},  label )

const Note = ({ icon, isWarn, children }) => (
  _react2.default.createElement('div', { className: _classBuilder2.default.call(void 0, 'new-chat--note', isWarn && 'new-chat--note---warn'), role: "status", __self: this, __source: {fileName: _jsxFileName, lineNumber: 414}}
    ,  icon 
    , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 416}},  children )
  )
)










const PersonRow = ({ entity, trailing, isDisabled, onClick, role, ariaChecked }) => {
  const body = (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement(_Avatar.EntityAvatar, { entity: entity, size: 40, __self: this, __source: {fileName: _jsxFileName, lineNumber: 432}} )
      , _react2.default.createElement('span', { className: "new-chat--row-text", __self: this, __source: {fileName: _jsxFileName, lineNumber: 433}}
        , _react2.default.createElement('span', { className: "new-chat--row-names", __self: this, __source: {fileName: _jsxFileName, lineNumber: 434}}
          , _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 435}},  entity.name )
          ,  entity.description && _react2.default.createElement('small', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 436}},  entity.description ) 
        )
        ,  trailing 
      )
    )
  )
  if (!onClick) return _react2.default.createElement('div', { className: "new-chat--row", __self: this, __source: {fileName: _jsxFileName, lineNumber: 442}},  body )
  return (
    _react2.default.createElement('button', {
      type: "button",
      role: role,
      'aria-checked': ariaChecked,
      disabled: isDisabled,
      className: _classBuilder2.default.call(void 0, 'new-chat--row', 'new-chat--row---button', isDisabled && 'new-chat--row---disabled'),
      onClick: onClick, __self: this, __source: {fileName: _jsxFileName, lineNumber: 444}}

      ,  body 
    )
  )
}

const PickRow =
  _react.memo.call(void 0, ({ entity, isOn, isDisabled, onToggle }) => (
    _react2.default.createElement(PersonRow, {
      entity: entity,
      isDisabled: isDisabled,
      role: "checkbox",
      ariaChecked: isOn,
      onClick: () => onToggle(entity),
      trailing: _react2.default.createElement('span', { className: _classBuilder2.default.call(void 0, 'new-chat--sel', isOn && 'new-chat--sel---on'), __self: this, __source: {fileName: _jsxFileName, lineNumber: 465}},  isOn && _react2.default.createElement(_icons.CheckIcon, { size: 13, __self: this, __source: {fileName: _jsxFileName, lineNumber: 465}} ) ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 459}}
    )
  ))

const ShortcutRow = ({
  icon, label, description, onClick,
}) => (
  _react2.default.createElement('button', { type: "button", className: "new-chat--row new-chat--row---button" , onClick: onClick, __self: this, __source: {fileName: _jsxFileName, lineNumber: 472}}
    , _react2.default.createElement('span', { className: "new-chat--shortcut-icon", __self: this, __source: {fileName: _jsxFileName, lineNumber: 473}},  icon )
    , _react2.default.createElement('span', { className: "new-chat--row-text", __self: this, __source: {fileName: _jsxFileName, lineNumber: 474}}
      , _react2.default.createElement('span', { className: "new-chat--row-names", __self: this, __source: {fileName: _jsxFileName, lineNumber: 475}}
        , _react2.default.createElement('b', { className: "new-chat--link", __self: this, __source: {fileName: _jsxFileName, lineNumber: 476}},  label )
        ,  description && _react2.default.createElement('small', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 477}},  description ) 
      )
    )
  )
)

exports. default = _react.memo.call(void 0, NewChat)
